import {Edit} from "@mui/icons-material";
import {Grid} from "@mui/material";
import React, {useEffect} from "react";
import {StereotypeDto} from "../../../../../common/apis/stereotype/StereotypeDto";
import TextField from "../../../../../components/fields/textfield/TextField";
import SectionActionBar from "../../../../../components/section/SectionActionBar";
import {SectionActionButton} from "../../../../../components/section/SectionActionButton";
import SectionHeader from "../../../../../components/section/SectionHeader";
import {t} from "../../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../../CommonTranslationKey";
import {ErrorTranslationKey} from "../../ErrorTranslationKey";
import Snackbar from "../../snackbar/Snackbar";
import {StereotypesTranslationKey} from "../StereotypesTranslationKey";
import {useLayoutDefinitionQuery} from "./LayoutDefinitionQuery";
import {LayoutDefinitionUpdateDialog} from "./LayoutDefinitionUpdateDialog";

export interface LayoutDefinitionPanelProps {
    stereotype: StereotypeDto;
    onUpdated: () => void;
}

export default function LayoutDefinitionPanel(props: Readonly<LayoutDefinitionPanelProps>) {
    const {stereotype, onUpdated} = props;

    const [updateDialogOpen, setUpdateDialogOpen] = React.useState(false);

    const {data: layout, isError, error, refetch} = useLayoutDefinitionQuery(stereotype.id, stereotype.layoutId);

    useEffect(() => {
        if (isError && error) {
            Snackbar.error(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), error);
        }
    }, [isError, error]);

    function openUpdateDialog() {
        setUpdateDialogOpen(true);
    }

    function closeUpdateDialog() {
        setUpdateDialogOpen(false);
    }

    function refresh() {
        refetch();
        onUpdated();
    }

    function stringifyToFormattedJson(object: Object): string {
        try {
            return JSON.stringify(object, null, "  ");
        } catch {
            return "";
        }
    }

    const layoutAsString = stringifyToFormattedJson(layout?.layout ?? "");

    return (
            <>
                <Grid container spacing={2} paddingBottom={0}>
                    <Grid item xs={12}>
                        <SectionHeader title={t(StereotypesTranslationKey.LAYOUT)}>
                            <SectionActionBar>
                                <SectionActionButton
                                        icon={<Edit fontSize={"inherit"}/>}
                                        tooltip={t(CommonTranslationKey.EDIT)}
                                        onClick={openUpdateDialog}
                                        visible={true}/>
                            </SectionActionBar>
                        </SectionHeader>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                                label={t(StereotypesTranslationKey.VERSION)}
                                value={layout?.version}
                                readOnly={true}
                                fullWidth/>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                                label={t(StereotypesTranslationKey.LAYOUT)}
                                value={layoutAsString}
                                multiline
                                rows={20}
                                readOnly={true}
                                InputProps={{sx: theme => ({fontSize: theme.typography.caption.fontSize})}}
                                fullWidth/>
                    </Grid>
                    <Grid item xs></Grid>
                </Grid>

                <LayoutDefinitionUpdateDialog open={updateDialogOpen}
                        stereotype={stereotype}
                        layoutDefinition={layout ?? undefined}
                        onUpdated={refresh}
                        onClose={closeUpdateDialog} />
            </>
    );
}